import './Channels.scss';
import { ChannelsNames } from './Channels';
import { appleBusinessChatStateName, instagramStateName, whatsAppEmbeddedStateName, } from './index';
export class ChannelsController {
    static $inject = ['ChannelsService', 'ChannelsSegmentService', 'ContextProcessorService', 'TenantService', 'LoadingService', 'application', '$state', '$window'];
    constructor(ChannelsService, ChannelsSegmentService, ContextProcessorService, TenantService, LoadingService, application, $state, $window) {
        'ngInject';
        this.ChannelsService = ChannelsService;
        this.ChannelsSegmentService = ChannelsSegmentService;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.LoadingService = LoadingService;
        this.application = application;
        this.$state = $state;
        this.$window = $window;
        this.excludedMessagingHubChannels = [];
        this.isTenantFree = true;
        this.appleBusinessChatStateName = appleBusinessChatStateName;
        this.instagramStateName = instagramStateName;
        this.whatsAppEmbeddedStateName = whatsAppEmbeddedStateName;
        this._onInit();
    }
    async _onInit() {
        this.LoadingService.startLoading();
        this.ChannelsSegmentService.setApplication(this.application);
        await this.checkTenantPlan();
        await this.ContextProcessorService.waitForInitialization();
        this.LoadingService.stopLoading();
        this.checkTokenInstagram();
        this.checkTokenMessenger();
        this.ChannelsService.setChannelsDeploymentStatuses();
    }
    async checkTokenInstagram() {
        const isValidPageToken = await this.checkTokenIsValid(ChannelsNames.Instagram);
        if (!isValidPageToken) {
            await this.toggleTokenInstagramExpiredAlert();
        }
    }
    async checkTokenMessenger() {
        const isValidPageToken = await this.checkTokenIsValid(ChannelsNames.Messenger);
        if (!isValidPageToken) {
            await this.toggleTokenMessengerExpiredAlert();
        }
    }
    async checkTenantPlan() {
        const tenantId = this.TenantService.getTenantPrefixFromUrl();
        const initPromises = [];
        initPromises.push(this.TenantService.getTenantPlan(tenantId));
        initPromises.push(this.ChannelsService.init(this.application));
        const [plan] = await Promise.all(initPromises);
        this.isTenantFree = plan === 'standard';
    }
    isChannelActive(channel) {
        return this.ChannelsService.isChannelActive(channel);
    }
    async toggleTokenInstagramExpiredAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=tokens-instagram-expired]');
        await bdsAlert.toggle();
    }
    async toggleTokenMessengerExpiredAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=tokens-messenger-expired]');
        await bdsAlert.toggle();
    }
    showUpgradePageOrGoToState(upgradeLink, state, saveBreadcrumb) {
        const channel = state.split('.').pop();
        if (this.isTenantFree && !this.isChannelActive(channel)) {
            this.trackConnectionStateOpened(channel, 'upgrade');
            this.$window.open(upgradeLink, 'blank', 'noopener noreferrer');
        }
        else {
            this.goToState(state, saveBreadcrumb);
        }
    }
    goToState(state, saveBreadcrumb = false) {
        this.$state.go(state);
        const channel = state.split('.').pop();
        if (this.isChannelActive(channel)) {
            this.trackConnectionStateOpened(channel, 'connected');
        }
        else {
            this.trackConnectionStateOpened(channel, 'connection');
        }
        if (saveBreadcrumb) {
            this.saveNewIconClick(channel);
        }
    }
    showNewIcon(channelName) {
        if (localStorage.getItem(`clicked-channel-${channelName}`) === 'true') {
            return false;
        }
        return true;
    }
    saveNewIconClick(channelName) {
        localStorage.setItem(`clicked-channel-${channelName}`, 'true');
    }
    // Segment
    trackConnectionStateOpened(channel, action) {
        const payload = {
            channelName: channel,
            action,
        };
        this.ChannelsSegmentService.trackChannelCardClicked(payload);
    }
    trackTokenValidation(channel, typeError) {
        const payload = {
            channelName: channel,
            typeError: typeError,
        };
        this.ChannelsSegmentService.trackChannelConfigurationTokenExpired(payload);
    }
    async checkTokenIsValid(channelName) {
        const result = await this.ChannelsService.checkTokenIsValid(channelName);
        if (result.IsValidated && !result.IsValidAccessToken) {
            this.trackTokenValidation(channelName, result.TypeErrorSubCode);
            return result.IsValidAccessToken;
        }
        return true;
    }
}
ChannelsController.$inject = ['ChannelsService', 'ChannelsSegmentService', 'ContextProcessorService', 'TenantService', 'LoadingService', 'application', '$state', '$window'];
